import { Cancel, Task } from 'taskarian';
import LearningCollectionEditStore from '..';
import { callApi } from '../../../../../../Appy';
import { findLinkT } from '../../../../../../LinkyLinky';
import { Link } from '../../../../../../Resource/Types';
import { buildUrl } from '../../../Reactions/ReloadAllExperiences';
import { LearningCollectionError } from '../../../Types';
import { productCollectionLicenseUpdatedResourceDecoder } from '../Decoders';
import { UpdatingProductLicense } from '../Types';

export const updateProductLicense = (
  state: UpdatingProductLicense,
  store: LearningCollectionEditStore,
): Cancel =>
  Task.succeed<LearningCollectionError, ReadonlyArray<Link>>(store.links)
    .andThen(findLinkT('update-product-license'))
    .andThen(buildUrl(state.selectedProductLicense))
    .andThen(callApi(productCollectionLicenseUpdatedResourceDecoder, {}))
    .fork(store.loadError, store.buildingFromUpdatingLicense);
